// extracted by css-extract-rspack-plugin
export default {"old":"changeAddress__old--iib0q","edit":"changeAddress__edit--sGAg6","warningText":"changeAddress__warningText--aHU8A"};